import {ChangeDetectionStrategy, Component, input} from '@angular/core';

@Component({
    selector: 'xui-container',
    templateUrl: './container.component.html',
    styleUrls: ['./container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContainerComponent {
  readonly fullWidth = input(false);
}
